var styles = {"show":"Boutton-module_show__otC48","isSubmitting":"Boutton-module_isSubmitting__jxm-E","rotate-forever":"Boutton-module_rotate-forever__WRAGR"};

export { styles as default };
//# sourceMappingURL=Boutton.module.scss.js.map
